<script setup>
import { ContentLink } from "vue-datocms";

const isDatoCmsDraftEnabled = useDatoCmsDraftMode();
const router = useRouter();
const route = useRoute();
</script>

<template>
  <ContentLink
    v-if="isDatoCmsDraftEnabled"
    :on-navigate-to="(path) => router.push(path)"
    :current-path="route.path"
  />
</template>
